<section>
  <div class="row">
    <form class="needs-validation container-style" novalidate [formGroup]="formCurrency">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-12">
          <app-custom-audit-info [userNameCreate]="currencyContract.userNameCreate"
            [createDate]="currencyContract.createDate" [userNameUpdate]="currencyContract.userNameUpdate"
            [updateDate]="currencyContract.updateDate"
            [reserveSpace]="true"></app-custom-audit-info>
        </div>
      </div>
      <div class="row p-2">
        <div class="col-lg-12">
          <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-3 col-12">
              <app-custom-input-text formControlName="code" [labelText]="'Código'" [recovery]="true" [required]="true"
                (onChangeTextOnBlur)="changeCurrency($event)">
              </app-custom-input-text>
            </div>
            <div class="col-lg-9 col-md-9 col-sm-9 col-12">
              <app-custom-input-text formControlName="name" [labelText]="'Nombre'" [required]="true">
              </app-custom-input-text>
            </div>
            <div class="col-12 d-flex justify-content-end mt-1">
              <app-custom-button [label]="'Guardar'" [severity]="'primary'" [disabled]="disabledForm"
                [variant]="undefined" (onClick)="send()"></app-custom-button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>